/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class JiraServiceManagementSecurityAlertMapping extends models.JiraServiceManagementMappingBase {
    getFixupPrototypeFunction() { return JiraServiceManagementSecurityAlertMapping.fixupPrototype; }

    static newInstance(model: Partial<JiraServiceManagementSecurityAlertMapping>): JiraServiceManagementSecurityAlertMapping {
        let obj = Object.assign(new JiraServiceManagementSecurityAlertMapping(), model);
        JiraServiceManagementSecurityAlertMapping.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<JiraServiceManagementSecurityAlertMapping>): JiraServiceManagementSecurityAlertMapping {
        if (!model) return null;
        return JiraServiceManagementSecurityAlertMapping.newInstance(<JiraServiceManagementSecurityAlertMapping> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: JiraServiceManagementSecurityAlertMapping) {
        if (!obj) return;

        models.JiraServiceManagementSecurityAlertMapping.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: JiraServiceManagementSecurityAlertMapping): boolean {
        if (models.JiraServiceManagementMappingBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, JiraServiceManagementSecurityAlertMapping.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.attribute_mappings) {
            for (let val of this.attribute_mappings) {
                models.JiraServiceManagementIncidentManagementConfigurationMappingForSecurityAlert.fixupPrototype(val);
            }
        }
    }

    /**
     * List of Security Alert attribute enums.
     */
    description_attributes: Array<models.DescriptionAttributeForItsmSecurityAlert>;

    /**
     * List of Security Alert attribute mappings.
     */
    attribute_mappings: Array<models.JiraServiceManagementIncidentManagementConfigurationMappingForSecurityAlert>;

}
